import React from 'react';
import { useTranslation } from 'react-i18next';
import { Accessibility } from 'lucide-react';

/**
 * Inline animated badge that opens the Accessibility Center on click.
 * Place near primary CTAs to surface the accessibility commitment.
 */
export const AccessibilityBadge = ({ className = '', testId = 'a11y-badge' }) => {
  const { t } = useTranslation();

  const open = () => {
    window.dispatchEvent(new CustomEvent('chico:open-a11y'));
  };

  return (
    <button
      type="button"
      onClick={open}
      data-testid={testId}
      data-a11y-widget="badge"
      aria-label={t('a11y.badgeAria')}
      className={`group inline-flex items-center gap-2 pl-2 pr-4 py-2 rounded-full bg-white border-2 border-teal-500 text-teal-700 hover:bg-teal-50 hover:border-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 transition-colors a11y-badge-pulse ${className}`}
    >
      <span className="relative flex items-center justify-center w-7 h-7 rounded-full bg-teal-600 text-white">
        <Accessibility size={16} aria-hidden="true" />
        <span className="absolute inset-0 rounded-full bg-teal-500 opacity-70 a11y-badge-ring" aria-hidden="true" />
      </span>
      <span className="text-xs font-bold uppercase tracking-wider">
        {t('a11y.badgeLabel')}
      </span>
    </button>
  );
};

export default AccessibilityBadge;
